import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { QueryResult } from '../shared/object/queryResult.model';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class VendedorService {
  constructor(private gqlclient: GraphQLClient) { }

  obtenerSegunId(rut_empresa, sucursal_codigo, codigo, callback: Function) {
    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        codigo,
      },
    };

    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType) {
            vendedor {
              obtenerSegunId(entidad: $entidad) {
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  territorio_codigo
                  nombre
                  comision
                  fono1
                  fono2
                  estado
                  territorio_codigo
                  rut
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerSegunId;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerTodosParaReporte(rutEmpresa, sucursalCodigo, callback: Function) {
    const inputParams = {
      rutEmpresa,
      sucursalCodigo,
    };

    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 0 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    rut
                    estado
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerActivos(rutEmpresa, sucursalCodigo, callback: Function) {
    const inputParams = {
      rutEmpresa,
      sucursalCodigo,
    };

    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    rut
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerVendedores(rutEmpresa, sucursalCodigo, listaRubro, totalRubro, callback: Function) {
    const inputParams = {
      rutEmpresa,
      sucursalCodigo,
      listaRubro,
      totalRubro,
    };

    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $listaRubro: [Decimal], $totalRubro: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1, listaRubro: $listaRubro, totalRubro: $totalRubro } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    rut
                    listaRubro
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerActivosSegunFecha(
    inputParams: {
      empresa_rut: number;
      sucursal_codigo: number;
      fecha_desde: Date;
      fecha_hasta: Date;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $fecha_desde: Date, $fecha_hasta: Date) {
            pedido {
              obtenerPedidosSegunVendedor(filtro: { exacto: { empresa_rut: $empresa_rut, sucursal_codigo: $sucursal_codigo, fecha_desde: $fecha_desde, fecha_hasta: $fecha_hasta } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  __typename
                }
                respuesta {
                  registros {
                    cantidad
                    vendedor_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.pedido.obtenerPedidosSegunVendedor;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerVendedoresConfirmacionNventa(
    inputParams: {
      rutEmpresa: number;
      sucursalEmpresa: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
      soloAprobadosAnalisis: boolean;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int, $soloAprobadosAnalisis: Boolean) {
            vendedor {
              obtenerVendedorSegunConfirmacionNotaVenta(
                rutEmpresa: $rutEmpresa
                sucursalEmpresa: $sucursalEmpresa
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
                soloAprobadosAnalisis: $soloAprobadosAnalisis
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                  __typename
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerVendedorSegunConfirmacionNotaVenta;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: $entidad }, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    sucursal_codigo
                    rut_empresa
                    territorio_codigo
                    nombre
                    comision
                    fono1
                    fono2
                    estado
                    territorio_codigo
                    rut
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  }

  obtenerReporteVentasVendedoresResumen(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    territorio_codigo
                    territorioNombre
                    monto_neto
                    descuento
                    neto_total
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresResumenExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresDetalle(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    nombrecomuna
                    codigo
                    nombre
                    monto_neto
                    descuento
                    neto_total
                    bruto_total
                    ruta_codigo
                    ruta_nombre
                    codsuclegacy
                    recorrido_codigo
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresDetalleExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresClientes(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        cliente_con_venta: boolean;
        cliente_sin_venta: boolean;
        listaIptVentas: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClientes(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    nombrecomuna
                    nombreprovincia
                    territorio_codigo
                    territorioNombre
                    ipt_venta
                    total_maquina
                    monto_neto
                    descuento
                    neto_total
                    fecha_ingreso_cliente
                    monto_ultima_venta
                    dia_sin_venta
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClientes;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresClientesExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        cliente_con_venta: boolean;
        cliente_sin_venta: boolean;
        retornaExcel: true; // always true for Excel
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClientes(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClientes;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresClienteProductos(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClienteProductosAsync(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    formato_codigo
                    formato_nombre
                    rubro_nombre
                    familia_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    codigo
                    nombre
                    fecha_ult_venta
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                    listaUnidadesxDocumento {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      dia_emision
                      formato_codigo
                      cantidad
                      producto_codigo
                      precio_neto
                      precio_unitario
                      monto_total_neto
                      monto_total
                      sku
                      monto
                      vendedor_codigo
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClienteProductosAsync;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresClienteProductosExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        retornaExcel: true; // always true for Excel
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClienteProductos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClienteProductos;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresProductos(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresProductos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    formato_codigo
                    formato_nombre
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    codigo
                    nombre
                    fecha_ult_venta
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                    listaUnidadesxDocumento {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      dia_emision
                      formato_codigo
                      cantidad
                      producto_codigo
                      precio_neto
                      precio_unitario
                      monto_total_neto
                      monto_total
                      sku
                      monto
                      vendedor_codigo
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresProductos;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasVendedoresProductosExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        retornaExcel: true; // always true for Excel
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresProductos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresProductos;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVendedoresFamiliaDocumento(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaDocumento(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    familia_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    nombrecomuna
                    codsuclegacy
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaDocumento;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVendedoresFamiliaDocumentoExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaDocumento(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaDocumento;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVendedoresFamiliaFamilia(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaFamilia(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    familia_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    nombrecomuna
                    codsuclegacy
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaFamilia;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVendedoresFamiliaFamiliaExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaFamilia(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaFamilia;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVendedoresFamiliaProducto(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    familia_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    nombrecomuna
                    codsuclegacy
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaProducto;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVendedoresFamiliaProductoExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        listaRubro: any[];
        listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaProducto;
        callback({ mensajes, respuesta });
      }
    );
  }
}
